import { render } from "./AsideBar.vue?vue&type=template&id=fefd3f40"
import script from "./AsideBar.vue?vue&type=script&lang=js"
export * from "./AsideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__